module.exports = "<div>\r\n  <sliders-t1 ng-if=\"$ctrl.dbData.isCarousel\" cb-items=\"$ctrl.dbData.items\" cb-name=\"$ctrl.dbName\"></sliders-t1>\r\n  <div ng-if=\"!$ctrl.dbData.isCarousel\">\r\n    <a href=\"{{$ctrl.dbData.items[0].url ? $ctrl.dbData.items[0].url : '#'}}\" title=\"{{$ctrl.dbData.items[0].title}}\">\r\n      <img ng-src=\"{{$ctrl.dbData.items[0].imageUrl}}\" class=\"img-reponsive\">\r\n    </a>\r\n  </div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/home/sliders/sliders.view.html
 ** module id = 337
 ** module chunks = 0
 **/